import { HttpClient } from '../../httpClient'
import { LegacyWorkflowResponse } from './types'

export function getWorkflow(contentId: string | number, accountId?: number) {
  const url = new URL(
    `/api/v1/content/${contentId}/workflow/full`,
    window.location.origin
  )

  if (accountId) {
    url.searchParams.append('content_account_id', accountId.toString())
  }

  return HttpClient()
    .get<LegacyWorkflowResponse>(url.toString())
    .then((res) => res.data)
}
